module.exports = __webpack_public_path__ + "img/en-pc-step-1.ec1aa74a.png";